module.exports = __webpack_public_path__ + "img/question-icon.794a8e19.svg";